<div
  class="hmn-width__full hmn-height__full hmn-unit-details-calendar-cell hmn-padding__x2 hmn-cursor__pointer"
  style="position: relative">
  <div
    class="hmn-row__space"
    style="align-items: flex-end">
    <h3 class="hmn-color__accent hmn-hidden__before-md">{{ day_number }}</h3>
    <span class="hmn-color__accent hmn-hidden__after-md hmn-text__7">{{ day_number }}</span>

    <h5 class="hmn-color__accent-contrast hmn-hidden__before-md">{{ day_label || '' | translate | uppercase }}</h5>
    <span class="hmn-color__accent-contrast hmn-hidden__after-md hmn-text__7">
      {{ translated_day_label?.substring(0, 1) | uppercase }}
    </span>
  </div>

  <div class="hmn-unit-details-calendar-cell__booking-list hmn-column">
    <div
      *ngFor="let booking of getCellBookings()"
      class="hmn-row__align hmn-margin__x1-top">
      <app-shared-circle></app-shared-circle>
      <span
        class="hmn-color__primary hmn-text__7 hmn-margin__x1-left hmn-text__ellipsized"
        style="max-width: calc(100% - 24px)"
        [matTooltip]="booking.title || ''">
        {{ booking.start_date | date : 'h:mm a' }} - {{ booking.end_date | date : 'h:mm a' }} : {{ booking.unit_name }}
      </span>
    </div>
  </div>
</div>
